

























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import FileExport from './FileExport.vue';
import Message from '../util/MessageWorker';

@Component({
  name: 'TopToolbar',
  components: {
    FileExport
  }
})
export default class extends Vue {
  private previewStatus = 0;
  private dialogVisible = false;
  private sceneDialogVisible = false;
  private workFolder = null;
  private showPopover = false;
  private dialogFormVisible = false;
  private tempSceneUrl = '';
  private form = {
    name: '',
    url: ''
  };
  private search = '';

  async created() {
    const result = await Message.emit('home.setting.workFolder');
    this.workFolder = result;
  
    this.init();
    window.addEventListener('message', async event => {
      const { data } = event;
      if (!data.handler) return;
      if (data.handler === 'client.screen.capture') {
        this.form.url = data.url;
      }
    })   
  }

  private async previewHandler() {
    this.previewStatus = this.previewStatus === 0 ? 1 : 0;

    await Message.emit('generator.toolbar.previewView', {
      status: this.previewStatus
    });
  }

  private async init() {
    const result = await Message.emit('generator.scene.getParams');
    this.previewStatus = result.data.previewViewStatus;
  }

  private trashHandler() {
    this.$confirm('此操作将重置, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        await Message.emit('generator.toolbar.trash');
      })
      .catch(() => {});
  }

  private toolbarClick() {
    const viewFrame: any = document.querySelector('#viewContent');
    viewFrame.contentWindow.postMessage({ handler: 'document-click' }, '*');
  }

  private async saveScene() {
    this.dialogFormVisible = true;
    const viewFrame: any = document.querySelector('#viewContent');
    viewFrame.contentWindow.postMessage({ handler: 'html-2-canvas' }, '*');
  }

  private async prevScene() {
    await Message.emit('generator.scene.prevScene');
  }

  private async nextScene() {
    await Message.emit('generator.scene.nextScene');
  }

  private async sureSaveScene() {
    await Message.emit('generator.scene.saveScene', this.form);
    this.dialogFormVisible = false;
  }

  private async getSerializeTree () {
    const viewFrame: any = document.querySelector('#viewContent');
    viewFrame.contentWindow.postMessage({ handler: 'html-2-canvas' }, '*');
  }

  private async sceneHandler(name) {
    await Message.emit('generator.toolbar.initScene', {
      name,
    });
    this.showPopover = false;
  }

  allowDrop(draggingNode, dropNode, type) {
    if (dropNode.data.label === '二级 3-1') {
      return type !== 'inner';
    } else {
      return true;
    }
  }
  allowDrag(draggingNode) {
    return draggingNode.data.label.indexOf('三级 3-2-2') === -1;
  }

  openCode() {
    Message.emitView('generate.ide.toogle');
  }

}
